import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Levels } from "./components/Levels";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Testimonials } from "./components/Testimonials";
import { Clients } from "./components/Clients";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Levels />
      <Testimonials />
      <Projects />
      <Clients />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
